
// Suprime o overlay de erro do CRA para ResizeObserver (aviso inofensivo do browser)
const _origError = window.onerror;
window.onerror = (msg, ...args) => {
  if (typeof msg === 'string' && msg.includes('ResizeObserver loop')) return true;
  return _origError ? (_origError as any)(msg, ...args) : false;
};
window.addEventListener('error', e => {
  if (e.message?.includes('ResizeObserver loop')) {
    e.stopImmediatePropagation();
    e.stopPropagation();
    e.preventDefault();
  }
}, true); // capture phase para interceptar ANTES do CRA

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ApolloProvider } from '@apollo/client';
import './styles/custom-bootstrap.scss';
import 'bootstrap-icons/font/bootstrap-icons.css';
import App from './App';
import { apolloClient } from './apollo/client';
import { AuthProvider } from './context/AuthContext';
import { ApiErrorProvider } from './context/ApiErrorContext';
import { CarrinhoProvider } from './context/CarrinhoContext';
import { ToastProvider } from './context/ToastContext';
import { ProfileProvider } from './context/ProfileContext';
import ErrorAlert from './components/ErrorAlert';
import ToastAlert from './components/ToastAlert';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { inplayTheme } from './styles/inplayTheme';
import './services/setupAxiosInterceptors';
import NavigationBinder from './routes/NavigationBinder';
import ProfileRedirectHandler from './components/ProfileRedirectHandler';


ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ApolloProvider client={apolloClient}>
      <AuthProvider>
        <ApiErrorProvider>
          <ToastProvider>
            <ProfileProvider>
              <CarrinhoProvider>
                <ThemeProvider theme={inplayTheme}>
                  <CssBaseline />
                  {/* Wrapper aplica as CSS vars para toda a app */}
                  <div className="color-theme-inplay">
                    <BrowserRouter basename={process.env.PUBLIC_URL || '/'}>
                      <NavigationBinder />
                      <ProfileRedirectHandler />
                      <ErrorAlert />
                      <ToastAlert />
                      <App />
                    </BrowserRouter>
                  </div>
                </ThemeProvider>
              </CarrinhoProvider>
            </ProfileProvider>
          </ToastProvider>
        </ApiErrorProvider>
      </AuthProvider>
    </ApolloProvider>
  </React.StrictMode>
);
